export const mainMenu = () => {
  const toggleMenu = document.getElementById("toggleMenu");
  const toggleNavigation = document.getElementById("toggleNavigation");
  const navigation = document.getElementById("navigation");
  const navbarLogo = document.querySelector(".navbar__logo");
  const navbar = document.querySelector(".navbar");
  const body = document.body;
  const html = document.documentElement;
  const header = document.getElementById("header");

  const isDesktop = () => window.matchMedia("(min-width: 1024px)").matches;
  const isSmallScreen = () => window.matchMedia("(max-width: 576px)").matches;

  const addClasses = () => {
    navigation.classList.add("isActive");
    navbarLogo.classList.add("showSymbol");

    if (!isDesktop()) {
      toggleMenu.classList.add("active");
    }

    body.classList.add("menuIsOpen");
    // html.classList.add("no-scroll");
    if (header) {
      header.classList.add("menuIsOpen");
    }

    if (body.classList.contains("home") && isSmallScreen() && navbar) {
      if (navbar.classList.contains("isLight")) {
        navbar.classList.remove("isLight");
        navbar.classList.add("isDark");
      }
    }
  };

  const removeClasses = () => {
    navigation.classList.remove("isActive");
    navbarLogo.classList.remove("showSymbol");

    if (!isDesktop()) {
      toggleMenu.classList.remove("active");
    }

    body.classList.remove("menuIsOpen");
    // html.classList.remove("no-scroll");
    if (header) {
      header.classList.remove("menuIsOpen");
    }

    if (body.classList.contains("home") && isSmallScreen() && navbar) {
      if (navbar.classList.contains("isDark")) {
        navbar.classList.remove("isDark");
        navbar.classList.add("isLight");
      }
    }
  };

  const handleClickOutside = (event) => {
    if (
      !navigation.contains(event.target) &&
      !toggleMenu.contains(event.target)
    ) {
      removeClasses();
      document.removeEventListener("click", handleClickOutside);
    }
  };

  if (toggleNavigation && toggleMenu && navigation && navbarLogo) {
    toggleNavigation.addEventListener("mouseenter", () => {
      if (isDesktop()) addClasses();
    });

    toggleNavigation.addEventListener("mouseleave", (event) => {
      if (isDesktop() && !navigation.contains(event.relatedTarget)) {
        removeClasses();
      }
    });

    navigation.addEventListener("mouseenter", () => {
      if (isDesktop()) addClasses();
    });

    navigation.addEventListener("mouseleave", (event) => {
      if (isDesktop() && !toggleNavigation.contains(event.relatedTarget)) {
        removeClasses();
      }
    });

    toggleMenu.addEventListener("click", () => {
      if (!isDesktop()) {
        if (toggleMenu.classList.contains("active")) {
          removeClasses();
          document.removeEventListener("click", handleClickOutside);
        } else {
          addClasses();
          setTimeout(() => {
            document.addEventListener("click", handleClickOutside);
          }, 0);
        }
      }
    });
  }

  window.addEventListener("resize", () => {
    if (isDesktop()) {
      document.removeEventListener("click", handleClickOutside);
      removeClasses();
    }
  });
};
